import { render } from "./AsideComponent.vue?vue&type=template&id=10c8ac8e&scoped=true"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"

import "./AsideComponent.vue?vue&type=style&index=0&id=10c8ac8e&lang=scss&scoped=true"

import exportComponent from "/Users/yq-qianduan/Documents/yq-home-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c8ac8e"]])

export default __exports__